<template>
  <div class="container mt-4">
    <div v-if="isLoading" class="text-center">
      <HMSpinner />
    </div>
    <div v-if="!isLoading && favourites && favourites.length">
      <div class="row">
        <div class="col-12 d-flex mb-4">
          <HMSearch class="flex-1 me-3" v-model="search" />
          <v-select
            :options="mediaTypeList"
            :placeholder="$t('PAYMENT_PLANS.LABELS.ALL_PRODUCTS')"
            class="media-type-select"
            v-model="typeFilter"
          >
            <template v-slot:selected-option="option">
              <span :class="option.icon" class="me-1"></span>
              <span class="d-inline-block text-truncate">
                {{ option.label }}
              </span>
            </template>
          </v-select>
        </div>
      </div>
      <div class="border p-4 rounded">
        <div class="row">
          <div class="col-12">
            <h3 class="m-0">{{ $t('STUDIO.LABELS.MY_FAVORITES') }}</h3>
          </div>
          <div
            v-for="favourite in favouritesFiltered"
            :key="favourite.id"
            class="col-sm-6 col-md-4 col-lg-3 p-3"
          >
            <NuxtLink
              class="undecorated-router-link"
              :to="{
                name: 'studio-media',
                params: {
                  media_id: favourite.id,
                  product_id: favourite.product_id,
                },
              }"
            >
              <StudioMediaCard :product="{}" :media="favourite" class="mb-0" />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
    <HMNoDataCard
      :title="$t('STUDIO.TITLE.NO_FAVORITES')"
      :description="$t('STUDIO.TEXT.BROWSE_MEDIA_INSIDE_A_PRODUCT')"
      toRouteName="studio-products"
      :toLabel="$t('STUDIO.LABELS.BROWSE_MY_PRODUCTS')"
      v-if="!isLoading && (!favourites || !favourites.length)"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { uniq } from 'lodash-es';
import { getMediaTypeLabel } from '@/utils/media';
import StudioMediaCard from '@/components/products/StudioMediaCard';

import { useStudioStore } from '@/stores';

export default {
  name: 'StudioMyFavorites',
  components: {
    StudioMediaCard,
  },
  setup() {
    definePageMeta({
      name: 'studio-my-favorites',

      isStudio: true,
      hideInstagramSlider: true,
      requiresAuth: true,
      showStudentNavigation: true,
    })
  },
  computed: {
    ...mapState(useStudioStore, {
      favourites: 'favourites',
    }),
    favouritesFiltered() {
      if (this.typeFilter === null) return this.favouritesSearched;
      return this.favouritesSearched.filter(
        favourite => favourite.media.file_content == this.typeFilter.code
      );
    },
    favouritesSearched() {
      if (!this.search) {
        return this.favourites;
      }
      return this.favourites.filter(
        favorite =>
          favorite.title &&
          favorite.title
            .toLowerCase()
            .indexOf(this.search.trim().toLowerCase()) > -1
      );
    },
    mediaTypeList() {
      const fileTypeList = uniq(
        this.favourites.map(favourite => favourite.media.file_content)
      ).map(fileType => ({
        label: this.$t(this.getMediaTypeLabel(fileType)),
        code: fileType,
      }));
      return fileTypeList;
    },
    studioURL() {
      return this.$studioURL;
    },
  },
  data() {
    return {
      isLoading: true,
      search: null,
      typeFilter: null,
    };
  },
  methods: {
    getMediaTypeLabel,
  },
  async mounted() {
    try {
      await useStudioStore().getStudentFavourites(this.studioURL);
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('STUDIO.NOTIFICATIONS.LOAD_FAVORITES_LIST_ERROR'),
        text: `Error: ${error}`,
        duration: -1, // stay ON
      });
    }
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.media-type-select {
  width: 200px;
}
</style>
